<template>
	<div class="LeadEdit lightTheme">
		<card  
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<div class="d-flex align-items-center justify-content-between" >
				<!-- <h3 class="mb-1 mr-2">{{strFIO}}</h3>  -->
				<!-- <span class="badge badge-pill badge-success" v-if="(objClient.client_type == 1) && bIsNew">ФИЗ ЛИЦО</span>
				<span class="badge badge-pill badge-primary" v-if="(objClient.client_type == 2) && bIsNew">ЮР ЛИЦО</span>	 -->
				<!-- <h3 class="mb-1 mr-2">strFIO</h3>  -->
				<!-- <span class="badge badge-pill badge-success" >ФИЗ ЛИЦО</span>
				<span class="badge badge-pill badge-primary" >ЮР ЛИЦО</span> -->

				<!-- <div class="d-flex align-items-center">
					<h4 class="mb-0">Контакт: </h4>
					<a href="" class="d-inline-flex col-md-7 align-items-center text-success">
						<i class="d-inline-block tim-ic ic-phone"></i>
						<span>contact_value2</span>
					</a>
				</div>	 -->
				<div class="d-flex align-items-baseline" >
					<h4 class="mb-0 mr-2 text-primary">Источник:</h4> 
					
					<p class="mb-0" v-if="objData.import_id && objData.import_id !=''"><span class="mr-1"  v-if="!bIsNew "> {{ this.objData.import_id }} </span></p>	
					<p class="mb-0" v-if="objData.dialed_number && objData.dialed_number !=''"> с номера <span class="text-primary"  v-if="!bIsNew "> {{ this.$GVO.formatPhoneNumber(this.objData.dialed_number) }}</span></p>	
					
				</div>
				<div>
					<div class="bntGroup">
						<base-button @click="GoToEdit(false)" type="primary" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
					</div>

				</div>	
			</div>
			<div class="d-flex align-items-baseline" v-if="objData.client_id!=''">
				<h4 class="mb-0 mr-2 text-primary">Клиент: </h4> 				
				<p v-if="objData.client_name!=''" class="mr-1">{{objData.client_name}}</p>
				<p v-if="objData.client_patronymic!=''" class="mr-1">{{objData.client_patronymic}}</p>
				<p v-if="objData.client_surname!=''" class="mr-1">{{objData.client_surname}}</p> 
				<h4 class="text-primary mb-0 mr-1 ml-4" v-if="(objData.client_contacts && objData.client_contacts.length>0) ||(objData.phone && objData.phone !='')">Контакты: </h4>	
				<p v-if="objData.client_contacts"> <ReClientContacts :contacts="objData.client_contacts"/></p>
				<p v-else-if="objData.phone && objData.phone!=''" class=""> {{ this.$GVO.formatPhoneNumber(this.objData.phone) }}</p>

				<div class="btnGroup pr-0 pl-1" v-if="$route.params.lead_id !='undefined' && objData.phone && objData.phone!=''">
						<RePhoneCallButton
							:phone="objData.phone"
							:lead_id="$route.params.lead_id"
							borderStyle="noborder"
						/>
				</div>

			</div>

			
			<!-- <h4 v-if="bIsNew">Редактирование данных лида</h4> -->
			<!-- <div class="col-md-12 checkbox-radios mb-3">
				<base-radio v-for="(el_opt, el_index) in rbClientType" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="rbClientType_model" inline>{{el_opt.label}}</base-radio>
			</div> -->
			<!-- <div v-if="!bIsNew" class="col-md-12 checkbox-radios mb-3">
				<base-radio v-for="(el_opt, el_index) in rbClientType" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="rbClientType_model" inline>{{el_opt.label}}</base-radio>
			</div> -->
			
			<hr>

			<tabs type="primary" 
				:activeTab="value"
				v-model="strCurTab"
				@change="OnTabChange"
				tabContentClasses="tab-opt"
				inline
				round	
				v-loading.fullscreen.lock="$GVO.fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"	
				class="card card-plain">
				<tab-pane :id="'lead'">
					<span slot="label" class="tab-label" @click="refreshPage()">
						<!--i class="tab-icon tim-icons icon-components "></i--><span>Новый лид</span>
					</span>
					<template>
						<ReFormPrinter 
							:masFormConfig="masAllFormParams" 
							:objSaveApiMethod="currentApiFormMethod"
							:SuccessGo="SuccessGo"
							@value-change="valueChange"/>
					</template>
				</tab-pane>

				<tab-pane :id="'leadhistory'" class="leadhistory">
					<span slot="label" class="tab-label">
						<!--i class="tab-icon tim-icons icon-align-left-2"></i--><span>Услуги</span>
					</span>				
					<template >
						<el-table 
						:data="masServices" 
						style="width: 100%">	
							<el-table-column
								label="Услуга"
								min-width="380"
								prop="service">
								<template v-slot="scope">
									<!--pre>{{ scope.row }}</pre-->
									<p v-if="scope.row.object_id!=''">ID объекта: <router-link :to="`/data/module/mo/object/${scope.row.object_id}`" class="mr-1"> {{scope.row.object_id}}</router-link> <span class="mr-2"><img :src="`${$GVO.endpoint_domen}/ajaxdata/object.php?code=${scope.row.object_id}`"/></span></p>		<!-- link -->
									<p v-if="scope.row.object_name!=''"><b>{{scope.row.object_name}}</b></p>
									<!-- <p>ID услуги: {{scope.row.id}}</p>-->
									<p>Источник: {{scope.row.lead_source}}</p>	
									<!-- <p>Тип недвижимости: </p>	 -->
									
									<p>Рекламный источник: {{ scope.row.adsSourceName }} </p>	
									<!-- <template v-if="scope.row.object_name ==''">
										<p>{{extra_serv_json(scope.row.extra_json)}}</p>
									</template>	 -->
									<!-- <p v-for="item in JSON.parse(scope.row.extra_json)" >{{item}}</p>	 -->
									<!-- <p>{{scope.row.extra_json.CHECKLIST.object_address}}</p>	 -->

									<p v-if="scope.row.object_name=='' && scope.row.operation_type!=''">Тип операци: {{scope.row.operation_type}}</p>	
									<p v-if="scope.row.object_name=='' && scope.row.lead_obj_type!=''">Тип объекта: {{scope.row.lead_obj_type}}</p>	
									<p v-if="scope.row.object_name=='' && scope.row.isNewBuilding!=''">Направление: 
										<span v-if="scope.row.isNewBuilding===0">Вторичка</span>
										<span v-if="scope.row.isNewBuilding!='' && scope.row.isNewBuilding==1">Новостройка</span>
										<span v-if="scope.row.isNewBuilding!='' && scope.row.isNewBuilding==4">Иное</span>
									</p>
									
									<!-- <p v-if="objData.client_id!=''">ИД клиента? {{objData.client_id}}</p> -->
									<!-- <p v-if="objData.AUTO_DISPATCH_CONTAINERFIELD_fio_padej!=''">{{objData.AUTO_DISPATCH_CONTAINERFIELD_fio_padej.name}}</p> -->
									<p>Добавлено: <b>{{$GVO.convertDateTimeFromMysql(scope.row.InsertTime)}}</b></p>	
									
								</template>
							</el-table-column>
							<!-- <el-table-column
								label="Время добавления"
								min-width="150"
								sortable
								prop="InsertTime">
								<template slot-scope="scope">
									
									<p>{{$GVO.convertDateTimeFromMysql(scope.row.InsertTime)}}</p>	
								</template>
								
							</el-table-column> -->

							<!-- <el-table-column
								label="Ответственный"
								min-width="250"
								prop="agent_name">
								<template slot-scope="scope">
									<a :href="`/data/staff/id/${scope.row.agent_id}`" class="mr-1"> {{scope.row.agent_name}}</a>
								</template>
							</el-table-column> -->

							<el-table-column
								label="Ответственный"
								min-width="350"
								prop="staff_info"
							>
								<template v-slot="scope">
									<div class="darkTheme">
										<router-link :to="`/data/staff/id/${scope.row.agent_id}`" class="mr-1"> {{scope.row.agent_name}}</router-link>
										<!-- <ReLeadStaffInfoMessage :objData="JSON.parse(scope.row.staff_info)" :lead_id="objData.id"  /> -->
										
										<ReLeadStaffInfoMessage 
											:client_id="objData.client_id" 
											:staffInfo="[scope.row.staff_info]" 
											:lead_id="objData.id"  
											:messageSent="`повторный запрос: ${objData.client_name} ${$GVO.endpoint_domen}/data/clients/id/${objData.client_id} ${scope.row.object_name}`"
										/>
										<!-- <ReLeadStaffInfoMessage :objData="JSON.parse(scope.row.staff_info)" :lead_id="objData.id" :objStaffExtra2="objStaffExtra[JSON.parse(scope.row.staff_info).staff_info_code]" /> -->
										<!-- <div>{{objStaffExtra[JSON.parse(scope.row.staff_info).staff_info_code]}}</div> -->
										
										
										<!-- <el-popover
										placement="left"
										:title="scope.row.agent_name"
										width="500"
										trigger="click"
										>
										<template slot="reference">
											<base-button class="btn btn-icon no-border btn-simple btn-primary my-0 ml-2 btn-watch-icon"><i class="tim-ic ic-eye"></i></base-button>
										</template>
										<template slot="default">
											<div class="col" >
												<ReLeadStaffInfo :objData="JSON.parse(scope.row.staff_info)" :lead_id="objData.id" />
											</div>
										</template>
									</el-popover> -->
									</div>
									
								</template>
							</el-table-column>
							<el-table-column
								width="180"
								label="Действие"
								prop="lead_id">
								<template v-slot="scope">
									<base-button class="ml-3 btn btn-simple btn-info" @click="ShowModal({row: scope.row, id:scope.row.id})">Сообщение клиенту</base-button>
									<base-button class="ml-3 btn btn-simple btn-success btn-repeat" @click="setRepeated(scope.row, scope.row.id)">Повторный звонок</base-button>
									
								</template>
							</el-table-column>
							
						</el-table>
						<!-- <pre>{{objStaffExtra}}</pre> -->
						<!-- <p>{{this.extra_json}}</p>	 -->
						<!--pre>{{ masServices }}</pre-->
						
					</template>	
				</tab-pane>

			</tabs>

			
			
			
		</card>
	</div>
</template>

<script>
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	// import { BaseRadio } from 'src/components/index';
	// import ReFioPadej from 'src/our_components/ReFioPadej.vue';
	import { TabPane, Tabs } from 'src/components';
	import { Table, TableColumn,  Select, Option, Tooltip, Button } from 'element-ui';
	// import ReLeadStaffInfo from 'src/our_components/ReLeadStaffInfo.vue';
	import ReLeadStaffInfoMessage from 'src/our_components/ReLeadStaffInfoMessage.vue';
	import RePhoneCallButton from "src/our_components/RePhoneCallButton.vue";
	import RepeatLeadMessage from '../our_modules/Lead/RepeatLeadMessage.vue';
	import ReClientContacts from '../our_components/ReClientContacts.vue';
	// import ThirdStep from '../pages/Forms/Wizard/ThirdStep.vue';

	export default {
		name: 'leadedit-page',
		components: {
			ReFormPrinter,
			// BaseRadio,
			// ReFioPadej,
			TabPane, 
			Tabs,
			[Table.name]: Table,
			[TableColumn.name]: TableColumn,
			[Option.name]: Option,
			[Select.name]: Select,
			[Tooltip.name]: Tooltip,
			[Button.name]: Button,
			// ReLeadStaffInfo,
			ReLeadStaffInfoMessage,
			RePhoneCallButton,
			ReClientContacts
		},
		props: {
			// objClient: Object,
			// objLead: Object,
			// leadPhone: String,
			value: {
				type: String,
				default: 'lead', 
			}, 
		},
		data () {
			return {
				ver: 1,
				strCurTab:'lead',
				masAllFormParams: this.currentFormConfig(),
				objData : {},
				masServices: [],
				// masAllFormParams: (typeof this.$route.query.client_type === 'undefined' || this.$route.query.client_type === '1')?this.currentFormConfig():this.TESTApiFormMethodCompUr(),//this.currentFormConfig()
				rbClientType: [{name: '1', label: 'ФИЗ ЛИЦО',},{name: '2', label: 'ЮР ЛИЦО',}],
				rbClientType_model: typeof this.$route.query.client_type !== 'undefined'?this.$route.query.client_type:'1',	
				strMethod: '',	
				dialed_number_formated: '',
				fullscreenLoading: false,
				requiredWatch: '{}',
				bIsNewVal: false,
				fullForm: false,
				objGetParams: [],
			}
		},
		watch:{
			rbClientType_model(val){
				// if(!this.bIsNew){
				// 	if(val == '1'){
				// 		// this.masAllFormParams = this.currentFormConfig();
				// 		this.masAllFormParams = this.TESTApiFormMethodComp();
				// 	}
				// 	if(val == '2'){
				// 		// this.masAllFormParams = this.currentFormConfigUr();
				// 		this.masAllFormParams = this.TESTApiFormMethodCompUr();
				// 	}
				// }
				if(val == '1'){
					// this.masAllFormParams = this.currentFormConfig();
					this.masAllFormParams = this.currentFormConfig();
				}
				if(val == '2'){
					// this.masAllFormParams = this.currentFormConfigUr();
					this.masAllFormParams = this.TESTApiFormMethodCompUr();
				}
				
			},
			/*
			bIsNewVal(val){
				if(location.pathname.indexOf('/data/callcenter/add') === -1){
					console.log('bIsNew');
					//.indexOf() will return -1 when the string isn't found, not 0.
					return false;
				}
				return true;
			}
			*/
			// fullForm(val){console.log('fullForm', val)},
		},
		computed: {
			currentApiFormMethod(){
				return this.currentApiFormMethodComp();
			},
			// bIsNew: function(){ // Проверка что это новый лид
				
			// 	get()
			// 	{
			// 		if(location.pathname.indexOf('/data/callcenter/add') === -1){
			// 		// console.log('bIsNew');
			// 		//.indexOf() will return -1 when the string isn't found, not 0.
			// 			// this.bIsNewVal = false;
			// 			return false;
						
			// 		} else {
			// 			// this.bIsNewVal = true;
			// 			return true;
			// 		}
			// 	}
			// 	set(newValue)
			// 	{
			// 		// this.bIsNewVal = newValue
			// 		newValue
			// 	}
			bIsNew: function(){ // Проверка что это новый лид
				const path=String(this.$router.history.current.path);
				// console.trace('ttt',path, path.indexOf('/data/callcenter/add'));
				if(path.indexOf('/data/callcenter/add') === -1){
					// console.log('bIsNew',false);
					//.indexOf() will return -1 when the string isn't found, not 0.
					return false;
				}
				// console.log('bIsNew',true);
				return true;
			},

			// strFIO: function(){
			// 	if(typeof this.objClient.id!='undefined'){
			// 		//return [this.objClient.surname,this.objClient.name,this.objClient.patronymic].join(' ');
			// 		return this.objClient.fio;
			// 	}
			// 	return 'Новый лид';
			// },
			
		},
		methods: {
			extra_serv_json(element){
				let extraJson = {};
				let jsonArray = [];
				
				if(element && element!=undefined){
					extraJson = JSON.parse(element);	
					// console.log(extraJson);
					if(extraJson.CHECKLIST){
						Object.keys(extraJson.CHECKLIST).forEach((key)=>{
							jsonArray.push({fields: extraJson.CHECKLIST[key].fields});
						});
						// console.log(extraJson.CHECKLIST);
						
					}
					//console.log(jsonArray);
					// return extraJson;
				}
				return jsonArray;
				// return false;
			},
			getRequiredWatch({isDeficient, objects_json}){
				// console.log(data, objects_json, isDeficient);
				// Мы теперь удаляем из объектов leadMessage, чтобы не мигать карточкой, когда вводятся данные
			
				if(objects_json>''){
					let j=JSON.parse(objects_json);
					if(Array.isArray(j)){
						j=j.map(({leadMessage, ...d})=>d);
						objects_json = JSON.stringify(j);
					}
				}
				return {
					isDeficient,
					objects_json,
				}
			},
			valueChange(data){
				// console.log('full?',this.fullForm,!this.bIsNew);
				if(!this.bIsNew){
					let req = this.getRequiredWatch(data);
					let reqStr = JSON.stringify(req);
					if(reqStr!=this.requiredWatch){
						// console.log('form-change', JSON.stringify(data));
						this.requiredWatch = reqStr;
						this.updateRequiredFields(req);
					}
					// console.log('valueChange',data);
				}
			},
			updateRequiredFields(data){
				this.$GVO.ApiCall('LEAD.GET_FORM_REQUIRED_FIELDS',{data})
					.then((objApi) => {
						if(objApi.success){
							// console.log('required', objApi.data,this);
							this.setRequiredFields(objApi.data);
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
			},
			setRequiredFields(fields){
				for(let el of this.masAllFormParams){
					if(el.elements){
						el.elements.forEach(element => {
							element.required = fields.indexOf(element.elementGetParamMap)>-1
						});
						// console.log(el);
					}
				}
			},
			currentFormConfig(){
				this.objGetParams = this.$GVO.GetAllGet();
				let lead_id = typeof this.$route.params.lead_id == 'undefined'?'-1':this.$route.params.lead_id;
				let filter = {};
				if (!this.$GVO.isEmpty(this.objGetParams)) {
					filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
				}
				// console.log('lead_id', lead_id);
				
				if(this.bIsNew || lead_id =='-1' ){ // Добавление лида
					this.fullForm = false;

					this.$GVO.ApiCall('LEAD.GET_FORM',{flt:{...filter, fullForm:false}})
					.then((objApi) => {
						// console.log(objApi);
						if(objApi.success){
							this.masAllFormParams = objApi.config;
							this.objData = {};
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
				} else {
					/*
					// для отладки переключения форм
					this.fullForm = false;
					this.$GVO.ApiCall('LEAD.GET_FORM',{flt:{fullForm:false}})
					.then((objApi) => {
						// console.log(objApi);
						if(objApi.success){
							this.masAllFormParams = objApi.config;
							this.objData = {};
						}
					})
					.catch(errorObjApi => console.log(errorObjApi));
					//*/
					this.getFullForm(lead_id)
					// setTimeout(()=>, 3000);
					
				}
				
				return [];

			},
			async beforeCallClient(){
				if(this.objData.client_id>0) return true;

				let client={};
				this.CallToAllFormField(this.masAllFormParams,element=>{
					switch(element.elementGetParamMap){
						case 'AUTO_DISPATCH_CONTAINERFIELD_fio_padej': client = {...client, ...element.element_model}; break;
						case 'isAgent':
						case 'phone':
							client[element.elementGetParamMap] = element.element_model
					}
				})
				const res = await this.$GVO.Api.LEAD.CHECK_CLIENT({iData:client});
				if(res.success==true){
					if(res.data && res.data[0]){
						this.objData.client_id = res.data[0].id;
					}
				}else{
					await this.$GVO.showAlert(res.msg);
					throw new Error(res.msg);
				}
				// asfdafgasf();
			},
			CallToAllFormField(form, cb){
				form.forEach(elements=>{
					Array.isArray(elements.elements) && elements.elements.forEach(cb)
				})
			},
			patchFormConfig(config){
				this.CallToAllFormField(config, element=>{
					if (element.elementGetParamMap == "phone"){
						element.beforeCall = this.beforeCallClient;
					}
				})
				return config;
			},
			getFullForm(lead_id){
				this.fullForm = true;
				// console.log('load full lead_id',lead_id);
				// console.log('load full',this,this.fullForm);
				this.$GVO.ApiCall('LEAD.GET_FORM',{flt:{id:lead_id}})
					.then((objApi) => {
						// console.log(objApi);
						if(objApi.success){
							
							this.masAllFormParams = this.patchFormConfig(objApi.config);
							this.$emit('form_refresh');
							this.objData = objApi.data;
							this.valueChange(this.objData);
							// console.log('sLEAD.GET_FORM',objApi);
							if(typeof this.objData.client_id !='undefined'){
								this.masServices = [];
								this.$GVO.ApiCall('services.GET',{flt:{'client_id':this.objData.client_id,'OnlyServ':true, staffExtra: true, lead:true,order_field:'s.InsertTime desc'}})
								.then((objApi) => {
									//console.log('services.GET',objApi);
									if(objApi.success){
										this.masServices = objApi.data.filter(s=>s.lead_id>0);
										// this.openFullScreen1();
										if(this.masServices.length>0){
											this.strCurTab = 'leadhistory';
											
											// console.log('services.GET',objApi);
											// for (let i = 0; i < this.masServices.length; i++) {
											// 	const staff_info = JSON.parse(this.masServices[i].staff_info);
											// 	// console.log('staff_info',staff_info);
											// 	if(typeof this.objStaffExtra[staff_info.staff_info_code] == 'undefined'){
											// 		this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':staff_info.staff_info_code}})
											// 		.then((objApi) => {
											// 			if(objApi.success === true){
											// 				this.objStaffExtra[staff_info.staff_info_code] = objApi.data[0];
											// 				console.log('this.objStaffExtra[staff_info.staff_info_code]',this.objStaffExtra[staff_info.staff_info_code]);
											// 			}
											// 		}).catch(errorObjApi => {console.log(errorObjApi);});
											// 	}
											// }
										}
									}
								})
								.catch(errorObjApi => console.error(errorObjApi));
							}
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
			},
			TESTApiFormMethodCompUr(){
				return require("src/conf/leadsAddLeacFormConfigUr.js").post_config;
			},
			
			currentApiFormMethodComp(){
				let lead_id = typeof this.$route.params.lead_id == 'undefined'?'0':this.$route.params.lead_id; // lead_id = 0, при открытии редактирования ручного лида
				// console.trace('api method', this.bIsNew);
				if(this.bIsNew){ // Добавление лида
					// console.log('ins', lead_id);
					return {apiMethod:'INSUPD',apiParam:{obj:'LEAD' ,flt:{id:'0'},iData:[]}};
				} else {
					// console.log('upd', lead_id);
					return {apiMethod:'INSUPD',apiParam:{obj:'LEAD' ,flt:{id:lead_id},iData:[]}};
				}
				
				// return {apiMethod:'INSUPD',apiParam:{obj:'LEAD' ,flt:{id:'0'},iData:[]}};
				//return {apiMethod:'INSUPD',apiParam:{obj:'LEAD' ,flt:{id:lead_id},iData:[]}};
			},
			
			SuccessGo(evt,dopParam){
				let lead_id = typeof this.$route.params.lead_id == 'undefined'?'0':this.$route.params.lead_id;
				
				//  console.log('success', this, lead_id);
				// console.log('this.bIsNew', this.bIsNew);
				// console.log('SuccessGo success',evt,dopParam);

				if(this.bIsNew == true || lead_id =='-1' ){ // Добавление лида
					// console.log('SuccessGo',evt,dopParam,typeof dopParam.data.new_id);

					// if(this.value.name !='' && this.value.name.length < 45){}else {
					// 	this.$GVO.showAlert('Плохое имя клиента','<p>Имя клиента не должно превышать 45 символов.</p>')
					// }

					if(typeof dopParam.data.new_id != 'undefined'){
						// location.href = '/data/callcenter/id/'+dopParam.data.new_id;
						// console.log(dopParam.data.new_id);
						this.fullscreenLoading = false;
						// this.$router.push({path: '/data/callcenter/id/'+dopParam.data.new_id});
						// this.bIsNewVal = false;
						this.$router.push({path: '/data/callcenter/id/'+dopParam.data.new_id+'/edit'}); // есди добавляем лид руками, то сохраняем и открываем сразу редактирование лида -- так не работает
						this.getFullForm(dopParam.data.new_id); 
						// this.openFullScreen1();
					}else{
						// console.log('this.$router.go(-11)');
						// this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id});
						this.$router.push({path: '/data/callcenter'});
					}
					
				}else{
					// console.log('this.$router.go(-22)');
					this.$router.push({path: '/data/callcenter'});
					//console.log('SuccessGo',evt);
				}
				sessionStorage.removeItem("lead-search-objects");
			},
			// Call(strPhone,obj_type,obj_id){
			// 	//console.log(strPhone);
			// 	this.$GVO.Call(strPhone,obj_type,obj_id);
			// },
			OnTabChange(strTabId){
				this.$emit('input', strTabId);
				this.$emit('change', strTabId);
				// if(strTabId == 'lead'){location.reload();}
			},
			GoToEdit(bGoEdit=true){
			//this.bIsEdit = bGo;
				if(bGoEdit){
					this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id+'/edit'});
					// this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id+'/edit?client_type='+this.masClient[0].client_type});
				}else{
					// this.$router.push({path: '/data/callcenter'});
					if(this.bIsNew){ // Добавление лида
						this.$router.push({path: '/data/callcenter'});
						//тут было sessionStorage
					}else{
						// console.log('this.$router.go(-2)');
						this.$router.go(-2);
						// this.$router.go(-2);
						// this.$router.back(-1);
						// this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id});
					}
					sessionStorage.removeItem("lead-search-objects");
				}
			},
			openFullScreen1(){
				this.fullscreenLoading = true;
				setTimeout(() => {
				this.fullscreenLoading = false;
				}, 2000);
			},
			setRepeated(rowData, service_id){
				// console.log(rowData);

				this.$GVO.ApiCall('LEAD.setLeadRepeatedStatus',{flt:{id:this.$route.params.lead_id},repeat_id:rowData.lead_id, service_id, lead_data: rowData})
				.then((objApi) => {
					// console.log(objApi);
					if(objApi.success === true){ 
						this.$router.push({path: '/data/callcenter/id/'+this.$route.params.lead_id});
					}else{
						if(objApi.msg){
							this.$GVO.showAlert('Вы что творите?',objApi.msg)
						}
					}
				}).catch(errorObjApi => {console.error(errorObjApi); });
			},
			refreshPage(){
				// location.reload();
				// console.log('refreshPage');
			},
			getRepeatMessage(row){
				const staff=JSON.parse(row.staff_info);
				if(row.object_id>0){
					// ${row.object_id} 
					return `Здравствуйте, ${this.objData.client_name}!
Вы интересовались объектом по адресу ${row.object_name}.\nВаш специалист ${staff.staff_info_fio}, номер для связи ${staff.staff_info_mobile_phone}.` // \n\nДанное сообщение сформировано автоматически, пожалуйста, не отвечайте на него.
				}
				return `Здравствуйте, ${this.objData.client_name}!
Спасибо, что обратились в компанию ${this.$GVO.my_profile.company_name||'Без названия'}.\nВаш специалист ${staff.staff_info_fio}, номер для связи ${staff.staff_info_mobile_phone}.` // \n\nДанное сообщение сформировано автоматически, пожалуйста, не отвечайте на него.
			},
			ShowModal(props){
				props.message=this.getRepeatMessage(props.row);
				props.phone = this.objData.phone;
				props.repeat_lead_id = this.$route.params.lead_id;
				if(this.objData.client_contacts){
					for(let c of this.objData.client_contacts){
						if(c.contact_type=='41'){
							props.phone = c.contact_value;
							break;
						}
					}
				}
				this.$modal(RepeatLeadMessage,{title:'Отправка уведомления',props});
				// this.$modal({render(h){return h(RepeatLeadMessage,p)}},{title:'Заголовок'});
			}
		},
		mounted() {
			
			// console.log(location.pathname.indexOf('/data/callcenter/add'));
			// console.log(location.pathname);
			this.objGetParams = this.$GVO.GetAllGet();
		},
		beforeMount(){
			
		}
	}
</script>
<style scoped>


	.LeadEdit {position: relative;}
	.LeadEdit hr{
		color:#01B0E0; 
		background-color: #01B0E0; 
		height: 2px;
		margin-top: 0;
	}
	.LeadEdit >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
	.LeadEdit .badge {font-size: 0.7rem; height: fit-content;}
	/* .LeadEdit >>> .form-options-group div {width: 100%; } */
	/* .LeadEdit >>> .form-options-group div {width: 55%; } */
	.LeadEdit >>> .ReFioPadej button {display: none;}
	.LeadEdit >>> .ReFioPadej .clear-btn {display: inline-flex;}
	.LeadEdit >>> .ReFioPadej {max-width: 436px;}

	/*Для удобства КЦ нужна минимальная форма, прэтому ниже издевательство над стилями формы */

	.LeadEdit >>> .form-options-group {
		flex-direction: row;
		flex-wrap: wrap;
		width: 100%;
		max-width: 1100px;
	}
	.LeadEdit >>> .form-options-group .elementWrapper:nth-child(7n)  {width: 100%;} 
	.LeadEdit >>> .form-options-group .elementWrapper:nth-last-child(-n+3) {width: 49%;} /* применить стили к последним 3 элементам .elementWrapper*/
	.LeadEdit >>>.cc-item, .LeadEdit >>> .form-group {margin-bottom: 0;}
	.LeadEdit >>>.ReInputSearchDrop {width: 100%;}
	.LeadEdit >>>.ReInputContact {margin-right: 15px;}
	.LeadEdit >>> textarea {
		width: 100%;
	}
	.LeadEdit >>> #objects_json {
		width: calc(100vw - 350px);
	}
	.LeadEdit >>> #isNewBuilding, .LeadEdit >>> #isDeficient {
		height: 100%;
	}
	/* .LeadEdit >>> #isNewBuilding > div, .LeadEdit >>> #isDeficient > div { */
	.LeadEdit >>> #isNewBuilding > div, .LeadEdit >>> #isDeficient {
		margin: 35px 0 0 0;
		/* margin: auto 0 0 0; */
	}
	.LeadEdit >>> #adsSourceName, .LeadEdit >>> #company_name {
		max-width: 436px;
		width: 100%;
	}
	.LeadEdit >>> #description, .LeadEdit >>> #agent_message, .LeadEdit >>> #client_message {margin-right: 5px;}
	
	.LeadEdit >>> #lead-call-cat, .LeadEdit >>> .ReFioPadej {
		margin-right: 15px;
	}
	.white-content .card:not(.card-white) >>> label {
		color: #000!important;
		/* color: #1d253b!important; */
	}
	/* .LeadEdit >>> .tree-list ul li, .LeadEdit >>> .tree-list span, .LeadEdit >>> .ReLeadStaffInfoMessage h6, .LeadEdit >>> .ReLeadStaffInfoMessage p  {color:inherit ;}  */
	/*#1d253b*/


	/* .LeadEdit >>> .white-content .card:not(.card-white)  >>> .tree-list ul li, 
	.LeadEdit >>> .white-content .card:not(.card-white)  >>> .tree-list span,  
	.white-content .card:not(.card-white) .darkTheme >>> .ReLeadStaffInfoMessage h6, 
	.white-content .card:not(.card-white)  >>> .LeadEdit .ReLeadStaffInfoMessage p  {color: #1d253b !important;}  */
	/** rgba(255, 255, 255, 0.8) */


	/* .LeadEdit >>>  #import_id .el-select, */
	/* .LeadEdit >>> [name^="Телефон_"], */
	/* .LeadEdit >>> #operation_type .el-select, */
	/* .LeadEdit >>> #lead_obj_type .el-select, */
	/* .LeadEdit >>> #name, */
	/* .LeadEdit >>> #adsSourceName .el-select, */
	/* .LeadEdit >>> #isNewBuilding .checkbox-radios { box-shadow: 0 1px 10px 0 rgba(246, 55, 55, 1) !important;} */
	.LeadEdit >>> #isNewBuilding .checkbox-radios { border: 1px solid #F84E54 !important; border-radius: 0.4285rem;}

	/*rgba(234, 143, 249, 1) -- красивый фиолетовый*/
	
	.LeadEdit >>> #lead_obj_type {margin-right: 15px;}
	.LeadEdit >>> #operation_type {margin-right: 1px;}
	.LeadEdit >>>  .textareaTemplate .form-control {
		height: 120px;
	}
	.el-table table .btn.btn-repeat{
		margin-top: 1px;;
	}
	/* .LeadEdit >>> .form-group.required input:placeholder-shown {
		border: 1px solid #F84E54; 
	}  */
	/* Red border only if the input is empty */
	
	@media (max-width: 1725px){
		/* .LeadEdit >>> #objects_json {max-width: 1000px;} */
	}

	@media (max-width: 670px){
		.LeadEdit >>> .ReFioPadej {max-width: 100%;}
		/* .LeadEdit >>> #objects_json {max-width: 500px;} */
		.LeadEdit >>> #isNewBuilding > div, .LeadEdit >>> #isDeficient > div {
			margin: auto 0 0 0;
		}
	}
</style>
